/**
 * 新增修改客户信息
 */
import React, { Component } from 'react';
import { Modal, Table, Divider,Button } from 'antd';
import Loading from '../../ui/Loading';

//联络信息
const billInfo = [{
    "text": "商户ID",
    "field": "clientId",
}, {
    "text": "商户名称",
    "field": "clientName",
}, {
    "text": "合约成交金额",
    "field": "totalAmount",
}, {
    "text": "押金金额",
    "field": "leaseDepositFee",
}, {
    "text": "铺位号",
    "field": "berths",
}, {
    "text": "合同编号",
    "field": "contractCode",
}, {
    "text": "起租时间",
    "field": "rentStartDate",
}, {
    "text": "退租时间",
    "field": "rentEndDate"
}];



const billList = [{
    title: '账单编号 ',
    dataIndex: 'number',
    width: '10%',
}, {
    title: '账单起始时间 ',
    dataIndex: 'startDate',
    width: '10%',
}, {
    title: '账单截止时间',
    dataIndex: 'endDate',
    width: '10%',
}, {
    title: '租金金额',
    dataIndex: 'rental',
    width: '10%',
}, {
    title: '管理费金额',
    dataIndex: 'managementFee',
    width: '10%',
}, {
    title: '最晚付款日',
    dataIndex: 'paymentDate',
    width: '10%',
}, {
    title: '付款状态',
    dataIndex: 'status',
    width: '10%',
}, {
    title: '账单合计金额',
    dataIndex: 'totalAmount',
    width: '10%',
}];


class BillInfoDetail extends Component {

    state = {
        visible: false,
        loading: false,
    }

    onRef = (field, dom) => {
        let dictSelect = this.state.dictSelect;
        dictSelect[field] = dom;
        this.setState({ dictSelect: dictSelect });
    }

    creaateDetailTable = (data) => {
        const { detailData } = this.props;
        let dom = [];
        let tdNum = 3;
        for (let i = 0; i < data.length; i += tdNum) {
            let td = [];
            for (let j = 0; j < tdNum && (i + j) < data.length; j++) {
                let text = (<td key={"td" + i + j}>{data[i + j]["text"] + "："}</td>);
                let colSpan = 1;
                if ((i + j) === (data.length - 1)) {
                    colSpan = (tdNum - j) * 2 - 1;
                }
                let field = (<td key={"td" + i + j + 1} colSpan={colSpan}>{detailData[data[i + j]["field"]]}</td>);
                td.push(text);
                td.push(field);
            }
            let tr = (<tr key={"tr" + i}>{td}</tr>);
            dom.push(tr);
        }
        let table = (
            <table className="application-detail-table">
                <tbody>
                    {dom}
                </tbody>
            </table>
        );
        return table;
    }

    hiddenModal = () => {
        this.setState({ visible: false });
    };

    showModal = (field) => {
        this.setState({ visible: true });
    };


    render() {
        const { visible, onCancel, detailData } = this.props;
        return (
            <Modal
                width={1000}
                visible={visible}
                title="账单信息详情"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={this.afterClose}
                footer={<Button key="cancel" type="default" onClick={onCancel}>关闭</Button>}
            >
                <div>
                <Divider orientation="left" style={{ marginTop: 0 }}>账单基本信息</Divider>
                {this.creaateDetailTable(billInfo)}
                <Divider orientation="left" style={{ marginTop: 0 }}>账单列表</Divider>
                <Table rowKey="id"
                                columns={billList}
                                dataSource={detailData["billList"] == null ? [] : detailData["billList"]}
                                pagination={false}
                                style={{ border: '1px solid #e8e8e8', borderBottom: 0 }}
                            />
                </div>
                <Loading
                    visible={this.state.loadingVisible}
                    message="正在保存"
                />
            </Modal>
        );
    }
}

export default BillInfoDetail;